import { getContext } from '@/miniappContext';

export const closeMiniapp = async (): Promise<void> => {
  try {
    const context = getContext();
    const { route } = context.general.location.getState();

    if (route.includes('ai-stylist')) {
      context.handlers.navigate('/create', undefined, undefined);
      return;
    }

    await context.handlers.close();
  } catch (error) {
    console.error('[closeMiniapp] Failed to close miniapp:', error);
  }
};
